import { ListingType } from "@redotech/redo-model/inventory/base-listing";
import { ProductFamilyDetailsSchema } from "@redotech/redo-model/inventory/general-listing/general-listing";
import { ListingsWithStatusSchema } from "@redotech/redo-model/inventory/listing-status";
import { ListingMappingSchema } from "@redotech/redo-model/inventory/listing-types";
import { productFamilyIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";
import {
  ImageSchema as ListingImageSchema,
  ProductImagesSchema,
  SelectedImageSchema,
} from "../listing-images/get-available-listing-images";

export const ProductFamilyMappingsSchema = z.object({
  shopifyMappings: ListingMappingSchema[ListingType.Shopify],
  redoMarketplaceMappings: ListingMappingSchema[ListingType.RedoMarketplace],
  chatGptMappings: ListingMappingSchema[ListingType.ChatGpt],
  ebayMappings: ListingMappingSchema[ListingType.Ebay],
  googleShoppingMappings: ListingMappingSchema[ListingType.GoogleShopping],
});
export type ProductFamilyMappings = z.infer<typeof ProductFamilyMappingsSchema>;

const AvailableListingImagesSchema_ = z.object({
  productFamilyImages: z.array(ListingImageSchema),
  productImages: z.array(ProductImagesSchema),
  selectedImages: z.array(SelectedImageSchema).nullable(),
});
export const AvailableListingImagesSchema: z.ZodType<AvailableListingImages> =
  AvailableListingImagesSchema_;
export interface AvailableListingImages extends z.infer<
  typeof AvailableListingImagesSchema_
> {}

export const getProductFamilyDetails = {
  name: "getProductFamilyDetails" as const,
  input: z.object({ productFamilyId: productFamilyIdFormat.schema }),
  output: z.object({
    productFamily: ProductFamilyDetailsSchema.nullable(),
    mappings: ProductFamilyMappingsSchema,
    listings: ListingsWithStatusSchema,
    availableListingImages: AvailableListingImagesSchema.nullable(),
  }),
};
